'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import clsx from 'clsx';
import React from 'react';
import { ContentEditLink } from '../Molecules/ContentEditLink';
import { PageTransition } from '../Molecules/PageTransition';
import { ParagraphContent } from '../Molecules/ParagraphContent';
export function PageDisplay(page) {
    return /*#__PURE__*/ React.createElement(PageTransition, null, /*#__PURE__*/ React.createElement("div", {
        id: "block-canopy-content"
    }, /*#__PURE__*/ React.createElement("div", null, page.title && /*#__PURE__*/ React.createElement("h1", {
        className: clsx(page.hideTitle && 'visually-hidden')
    }, page.title), page.editLink ? /*#__PURE__*/ React.createElement(ContentEditLink, _object_spread({
        className: clsx('mb-4', !page.hideTitle ? '-mt-4' : 'mt-4')
    }, page.editLink)) : null, page.content && /*#__PURE__*/ React.createElement(ParagraphContent, {
        pageNode: page,
        content: page.content
    }))));
}
